const testimonialStyle = (theme) => ({
  slideSwiper: {
    width: '100%'
  },

  paginationBox: {
    justifyContent: 'center',
    textAlign: 'center',
    height: 30,
    position: 'relative',

    '.swiper-pagination-bullet-active': {
      backgroundColor: theme.palette.primary.main
    }
  },

  slideCard: {
    display: 'flex',
    position: 'relative',
    margin: 20,
    cursor: 'pointer',

    '.cardMedia': {
      width: '100%',
      position: 'relative',
      overflow: 'hidden'
    },

    '&.expanded': {
      height: '70%',
      position: 'absolute',
      width: 600,

      '.cardMedia': {
        background: 'grey'
      }
    }
  },

  videoPlayer: {
    video: {
      objectFit: 'cover',
      zIndex: 1
    },
    '&.isExpanded': {
      video: {
        objectFit: 'contain'
      }
    }
  },

  playButton: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'none',

    '&.show': {
      display: 'flex',
      zIndex: 3
    },

    '.MuiSvgIcon-root': {
      color: 'rgba(255, 255, 255, 0.5)',
      fontSize: '4.2rem'
    }
  },

  testimonial: {
    padding: 20,
    minHeight: 140,
    display: 'flex',
    flexDirection: 'column',

    p: {
      textAlign: 'left',
      marginBottom: 10
    },

    '.praise': {
      display: 'flex',
      flexGrow: 1
    },

    '.author': {
      display: 'flex',
      color: theme.palette.grey.main
    }
  },

  closeButton: {
    position: 'absolute',
    right: 10,
    top: 10,
    zIndex: theme.zIndex.drawer + 1
  }
});

export default testimonialStyle;
